var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import * as rawJSONSchemaModuleCancerVulval from '../../schemas/module-cancer-vulval.json';
var ModuleValueCancerVulval = (function (_super) {
    __extends(ModuleValueCancerVulval, _super);
    function ModuleValueCancerVulval() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueCancerVulval;
}(ModuleValueGeneral));
var SchemaModuleCancerVulval = (function (_super) {
    __extends(SchemaModuleCancerVulval, _super);
    function SchemaModuleCancerVulval() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleCancerVulval);
        return _this;
    }
    SchemaModuleCancerVulval.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
        this.listenValue('follow_up_duration_compute', this.fieldHandlerFollowUpDurationCompute.bind(this));
        this.listenValue(['date_last_follow_up', 'main_procedure', 'date_of_surgery', 'date_radiation_commenced'], this.fieldHandlerCalculateFollowUpDuration.bind(this));
    };
    SchemaModuleCancerVulval.prototype.fieldHandlerCalculateFollowUpDuration = function (followUpDate, mainProcedure, surgeryDate, radiationDate) {
        if (!this.getValue('follow_up_duration_compute'))
            return;
        var startDate = this.resolveStartDate(mainProcedure, surgeryDate, radiationDate);
        this.updateValue('follow_up_duration', this.diffInMonths(followUpDate, startDate, 30.5));
    };
    SchemaModuleCancerVulval.prototype.fieldHandlerFollowUpDurationCompute = function (compute) {
        if (typeof compute === 'undefined' || compute === null)
            return;
        this.schema.properties['follow_up_duration'].readOnly = compute;
        if (compute) {
            this.fieldHandlerCalculateFollowUpDuration(this.getValue('date_last_follow_up'), this.getValue('main_procedure'), this.getValue('date_of_surgery'), this.getValue('date_radiation_commenced'));
        }
    };
    SchemaModuleCancerVulval.prototype.resolveStartDate = function (mainProcedure, surgeryDate, radiationDate) {
        if (mainProcedure === 'upfront_chemoradiation')
            return radiationDate;
        return surgeryDate;
    };
    SchemaModuleCancerVulval.prototype.setupValidators = function () {
        _super.prototype.setupValidators.call(this);
        this.validatorDateComparison('date_of_diagnosis', 'date_of_birth', '>');
        this.validatorDateComparison('date_of_surgery', 'date_of_birth', '>');
        this.validatorDateComparison('date_of_surgery', 'date_of_diagnosis', '>=');
        this.validatorDateComparison('date_radiation_commenced', 'date_of_birth', '>');
        this.validatorDateComparison('date_radiation_commenced', 'date_of_diagnosis', '>=');
        // this.validatorDateComparison( 'recurrence_progression_date', 'date_of_birth', '>' );
        // this.validatorDateComparison( 'recurrence_progression_date', 'date_of_diagnosis', '>=' );
        // this.validatorDateComparison( 'recurrence_progression_date', 'date_of_surgery', '>=' );
        // this.validatorDateComparison( 'date_last_follow_up', 'date_of_birth', '>' );
        // this.validatorDateComparison( 'date_last_follow_up', 'date_of_diagnosis', '>=' );
        // this.validatorDateComparison( 'date_last_follow_up', 'date_of_surgery', '>=' );
        this.validatorDate('date_of_birth', (new Date()), '<=', function (v) { return new Date(v); });
        this.validatorDate('date_of_diagnosis', (new Date()), '<=', function (v) { return new Date(v); });
    };
    return SchemaModuleCancerVulval;
}(SchemaModuleGeneral));
export { SchemaModuleCancerVulval };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-cancer-vulval.ts.pre-build-optimizer.js